import { useState } from "react";
import { ParticipantAdminEditDisplay } from "../../Interfaces/FundraiserRole";
import config from "../../config";
import "./ImageProfilePreview.css";
interface ImagePreviewProps {
  participant: ParticipantAdminEditDisplay;
  onRemove: (reason: string, participant_id: number) => void;
}

export default function ImagePreview({
  participant,
  onRemove,
}: ImagePreviewProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [removalReason, setRemovalReason] = useState("");
  const isFeatureEnabled = false;
  return (
    <div>
      {/* Small Circular Image Preview */}
      <div
        className={`image-preview-profile-image-container ${
          !isFeatureEnabled ? "disabled-click" : ""
        }`}
        onClick={isFeatureEnabled ? () => setIsOpen(true) : undefined}
      >
        <img
          src={`${config.BACKEND_BASE_IMAGE_LOCATION}${
            participant.profile_image_url ||
            "/media/images/site_aesthetic/headshot-silhouette-30.png"
          }`}
          alt="Profile"
          className="profile-image"
        />
      </div>

      {/* Popup Dialog */}
      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg w-96">
            <h2 className="text-lg font-semibold mb-4">Remove Image</h2>
            <img
              src={`${config.BACKEND_BASE_IMAGE_LOCATION}${
                participant.profile_image_url || ""
              }`}
              alt="Enlarged"
              className="w-full max-h-80 object-contain mb-4"
            />
            <input
              type="text"
              placeholder="Reason for profile picture removal"
              value={removalReason}
              onChange={(e) => setRemovalReason(e.target.value)}
              className="w-full p-2 border rounded mb-4"
            />
            <div className="flex justify-end gap-2">
              <button
                className="bg-red-500 text-white px-4 py-2 rounded"
                onClick={() => {
                  onRemove(removalReason, participant.participant_id);
                  setIsOpen(false);
                }}
              >
                Remove photo
              </button>
              <button
                className="bg-gray-300 px-4 py-2 rounded"
                onClick={() => setIsOpen(false)}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
